/* ATY · petits comportements des sections ATY (compte à rebours, ajout rapide) */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Dates saisies au format « AAAA-MM-JJ HH:MM », heure d'Abidjan (GMT). */
  function parseEnd(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0);
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-aty-cd]').forEach(function (el) {
      var end = el._atyEnd || (el._atyEnd = parseEnd(el.getAttribute('data-aty-cd')));
      if (isNaN(end)) return;
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      Object.keys(parts).forEach(function (k) {
        var b = el.querySelector('[data-u="' + k + '"]');
        if (b) { var v = pad(parts[k]); if (b.textContent !== v) b.textContent = v; }
      });
      el.classList.toggle('no-days', parts.d === 0);
      el.classList.toggle('no-hours', parts.d === 0 && parts.h === 0);
      var deal = el.closest('[data-aty-deal]');
      if (deal) {
        deal.classList.toggle('is-urgent', left > 0 && left < 3600);
        deal.classList.toggle('is-over', left === 0);
        var tb = deal.querySelector('[data-deal-tbar]'), dur = (+deal.getAttribute('data-dur') || 24) * 3600;
        if (tb) tb.style.width = Math.max(left > 0 ? 2 : 0, Math.min(100, left * 100 / dur)) + '%';
      }
      if (left === 0 && !el.classList.contains('is-done')) {
        el.classList.add('is-done');
        el.setAttribute('data-done-text', (el.getAttribute('data-done') || '').replace(/ ([!?:;»])/g, '\u00a0$1'));
        var section = el.closest('.aty-hide-after');
        if (section) section.hidden = true;
      }
    });
  }

  /* ---------- Outils partagés ---------- */
  var CFG = window.atyCfg || {};
  function money(cents) {
    var fmt = CFG.money || '{{amount}} F CFA';
    var n = (Number(cents) || 0) / 100;
    function group(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      if (parts[1] && /^0+$/.test(parts[1])) parts.pop();
      return parts.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(n, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    }).replace(/<[^>]+>/g, '');
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function splitTitle(title) {
    var t = String(title || '').replace(/ [-—] /g, ' – ').trim();
    var i = t.indexOf(' – ');
    if (i < 0) return { name: t, sub: '' };
    var brand = t.slice(0, i).trim();
    var mode = CFG.brandCase || 'capitalize';
    if (mode === 'upper') brand = brand.toUpperCase();
    else if (mode === 'capitalize') brand = brand.toLowerCase().split(' ').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    return { name: brand, sub: t.slice(i + 3).trim() };
  }
  function optLabel(name) {
    var n = String(name || '').toLowerCase();
    if (n === 'size') return 'Taille';
    if (n === 'color' || n === 'colour') return 'Couleur';
    return name;
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Ajout au panier puis ouverture du tiroir panier */
  function addToCart(id, onError) {
    var root = CFG.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { onError(res.description || res.message || 'Impossible d’ajouter ce produit.'); return false; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = root + 'cart';
        }
        if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'aty-quick-add' }); } catch (e) {} }
        return true;
      })
      .catch(function () { onError('Connexion impossible, réessaie.'); return false; });
  }

  /* ---------- Fenêtre d'ajout rapide ---------- */
  var dlg = null;
  function getDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'aty-qd';
    dlg.setAttribute('aria-label', 'Ajout rapide au panier');
    dlg.innerHTML = '<div class="aty-qd__box"><button type="button" class="aty-qd__close" data-qd-close aria-label="Fermer"><svg class="aty-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button><div data-qd-body></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-qd-close]')) dlg.close();
    });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('aty-noscroll'); });
    return dlg;
  }

  function openQuickAdd(btn) {
    var url = btn.getAttribute('data-aty-qa');
    var direct = btn.getAttribute('data-variant');
    if (direct) {
      btn.classList.add('is-loading');
      addToCart(direct, function () { window.location.href = url; }).then(function () { btn.classList.remove('is-loading'); });
      return;
    }
    btn.classList.add('is-loading');
    fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { btn.classList.remove('is-loading'); renderQuickAdd(p); })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = url; });
  }

  function renderQuickAdd(p) {
    var d = getDialog();
    var body = d.querySelector('[data-qd-body]');
    var t = splitTitle(p.title);
    var options = (p.options || []).map(function (o, i) {
      return typeof o === 'string' ? { name: o, position: i + 1, values: [] } : o;
    });
    options.forEach(function (o, i) {
      if (!o.values || !o.values.length) {
        o.values = [];
        p.variants.forEach(function (v) { var val = v.options[i]; if (o.values.indexOf(val) < 0) o.values.push(val); });
      }
    });
    var sel = options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
    /* La couleur de la photo affichée est présélectionnée, la taille reste à choisir */
    options.forEach(function (o, i) {
      var n = String(o.name).toLowerCase();
      if (sel[i] === null && /coul|colo/.test(n)) {
        var firstAvail = p.variants.filter(function (v) { return v.available; })[0];
        if (firstAvail) sel[i] = firstAvail.options[i];
      }
    });

    function variantImage(i, val) {
      for (var k = 0; k < p.variants.length; k++) {
        var v = p.variants[k];
        if (v.options[i] === val && v.featured_image) return v.featured_image.src;
      }
      return '';
    }
    var html = '<div class="aty-qd__top"><img class="aty-qd__img" data-qd-img src="' + esc(imgUrl(p.featured_image, 300)) + '" alt="">' +
      '<div><div class="aty-qd__name">' + esc(t.name) + '</div>' + (t.sub ? '<div class="aty-qd__sub">' + esc(t.sub) + '</div>' : '') +
      '<div class="aty-qd__price" data-qd-price></div></div></div>';
    options.forEach(function (o, i) {
      var isColor = /coul|colo/.test(String(o.name).toLowerCase());
      html += '<div class="aty-qd__opt" data-qd-opt="' + i + '"><div class="aty-qd__legend">' + esc(optLabel(o.name)) + ' : <b data-qd-optval></b></div><div class="aty-qd__vals">';
      o.values.forEach(function (val) {
        var im = isColor ? variantImage(i, val) : '';
        html += '<button type="button" class="aty-qd__val" data-val="' + esc(val) + '" aria-pressed="false">' +
          (im ? '<img src="' + esc(imgUrl(im, 80)) + '" alt="">' : '') + esc(val) + '</button>';
      });
      html += '</div></div>';
    });
    html += '<p class="aty-qd__err" data-qd-err role="alert" hidden></p>' +
      '<button type="button" class="aty-btn aty-btn--primary aty-btn--lg aty-btn--block aty-qd__add" data-qd-add>Ajouter au panier</button>' +
      '<a class="aty-qd__more" href="' + esc(p.url) + '">Voir la fiche produit</a>';
    body.innerHTML = html;

    var addBtn = body.querySelector('[data-qd-add]');
    var err = body.querySelector('[data-qd-err]');
    var current = null;

    function find() {
      if (sel.some(function (x) { return x === null; })) return null;
      return p.variants.filter(function (v) { return v.options.every(function (o, j) { return o === sel[j]; }); })[0] || null;
    }
    function update() {
      current = find();
      body.querySelectorAll('[data-qd-opt]').forEach(function (box) {
        var i = Number(box.getAttribute('data-qd-opt'));
        box.querySelector('[data-qd-optval]').textContent = sel[i] || '';
        box.querySelectorAll('[data-val]').forEach(function (b) {
          var val = b.getAttribute('data-val');
          b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
          var ok = p.variants.some(function (v) {
            if (!v.available || v.options[i] !== val) return false;
            return v.options.every(function (o, j) { return j === i || sel[j] === null || o === sel[j]; });
          });
          b.classList.toggle('is-out', !ok);
        });
      });
      var v = current || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var pr = body.querySelector('[data-qd-price]');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      pr.className = 'aty-qd__price' + (sale ? ' is-sale' : '');
      pr.innerHTML = '<span>' + esc(money(v.price)) + '</span>' + (sale ? '<s>' + esc(money(v.compare_at_price)) + '</s>' : '');
      var colorIdx = -1;
      options.forEach(function (o, i) { if (/coul|colo/.test(String(o.name).toLowerCase())) colorIdx = i; });
      var im = (current && current.featured_image && current.featured_image.src) || (colorIdx > -1 && sel[colorIdx] ? variantImage(colorIdx, sel[colorIdx]) : '');
      if (im) body.querySelector('[data-qd-img]').src = imgUrl(im, 300);
      if (!current) {
        var missing = options.filter(function (o, i) { return sel[i] === null; }).map(function (o) { return optLabel(o.name).toLowerCase(); });
        addBtn.textContent = missing.length ? 'Choisis ta ' + missing[0] : 'Indisponible';
        addBtn.disabled = !missing.length;
      } else if (!current.available) {
        addBtn.textContent = 'Épuisé';
        addBtn.disabled = true;
      } else {
        addBtn.textContent = 'Ajouter au panier';
        addBtn.disabled = false;
      }
    }
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-val]');
      if (b) {
        var i = Number(b.closest('[data-qd-opt]').getAttribute('data-qd-opt'));
        sel[i] = b.getAttribute('data-val');
        err.hidden = true;
        update();
        return;
      }
      if (e.target.closest('[data-qd-add]')) {
        if (!current) {
          err.textContent = 'Choisis d’abord ta taille.'; err.hidden = false;
          return;
        }
        addBtn.classList.add('is-loading');
        addToCart(current.id, function (msg) { err.textContent = msg; err.hidden = false; }).then(function (ok) {
          addBtn.classList.remove('is-loading');
          if (ok) d.close();
        });
      }
    });
    update();
    if (typeof d.showModal === 'function') {
      d.showModal();
      document.documentElement.classList.add('aty-noscroll');
    } else {
      window.location.href = p.url;
    }
  }

  /* Bouton d'ajout direct (formules du Club) */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-aty-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    add.classList.add('is-loading');
    addToCart(add.getAttribute('data-aty-add'), function (msg) { add.classList.remove('is-loading'); window.location.href = (CFG.root || '/') + 'cart'; })
      .then(function () { add.classList.remove('is-loading'); });
  });

  /* Deal de l'heure : choix de la taille, le bouton ajoute directement cette taille */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-deal-size]');
    if (!chip || chip.disabled) return;
    var deal = chip.closest('[data-aty-deal]');
    deal.querySelectorAll('[data-deal-size]').forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
    var cta = deal.querySelector('[data-deal-cta]');
    if (cta) {
      if (cta.hasAttribute('data-aty-qa')) cta.setAttribute('data-variant', chip.getAttribute('data-deal-size'));
      else cta.setAttribute('href', cta.getAttribute('href').split('?')[0] + '?variant=' + chip.getAttribute('data-deal-size'));
      var sub = cta.querySelector('[data-deal-ctasub]');
      if (sub) { if (!sub._t) sub._t = sub.textContent; sub.textContent = 'Taille ' + chip.getAttribute('data-label') + ' · ' + sub._t.split(' au lieu')[0]; }
      cta.classList.remove('is-pop'); void cta.offsetWidth; cta.classList.add('is-pop');
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aty-qa]');
    if (!btn) return;
    e.preventDefault();
    openQuickAdd(btn);
  });

  window.atyUtil = { money: money, splitTitle: splitTitle, addToCart: addToCart, esc: esc, imgUrl: imgUrl };

  function init() {
    tick();
    if (!window._atyTimer) window._atyTimer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Éditeur de thème : réinitialise quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) { tick(); });
})();


/* ATY · Favoris (gardés sur le téléphone), vus récemment et partage */
(function () {
  'use strict';
  var CFG = window.atyCfg || {};
  var FKEY = 'atyFav', RKEY = 'atyRecent', MAXF = 60, MAXR = 12;
  function load(k) { try { var v = JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function root() { var r = CFG.root || '/'; return r.slice(-1) === '/' ? r : r + '/'; }
  var HEART = '<svg class="aty-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.3s-7.8-4.6-7.8-10.2A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 7.8 2.7c0 5.6-7.8 10.2-7.8 10.2z"/></svg>';

  function sync() {
    var f = load(FKEY);
    document.querySelectorAll('[data-aty-fav]').forEach(function (b) {
      var on = f.indexOf(b.getAttribute('data-aty-fav')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-fav-label]');
      if (l) l.textContent = on ? 'Dans tes favoris' : 'Ajouter aux favoris';
    });
    document.querySelectorAll('[data-aty-favcount]').forEach(function (c) { c.textContent = String(f.length); c.hidden = !f.length; });
  }

  var toastT;
  function toast(html) {
    var t = document.getElementById('aty-toast');
    if (!t) { t = document.createElement('div'); t.id = 'aty-toast'; t.className = 'aty-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aty-fav]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-aty-fav');
      var f = load(FKEY);
      var i = f.indexOf(h);
      if (i > -1) { f.splice(i, 1); toast('Retiré de tes favoris'); }
      else { f.unshift(h); f = f.slice(0, MAXF); toast('Ajouté à tes favoris · <a href="' + (CFG.favUrl || '/pages/favoris') + '">Voir</a>'); }
      save(FKEY, f);
      sync();
      track(i > -1 ? 'remove' : 'add', h);
      var card = b.closest('[data-aty-favpage] .aty-card');
      if (card && i > -1) { card.remove(); renderLists(); }
      return;
    }
    var s = e.target.closest && e.target.closest('[data-aty-share]');
    if (s) {
      e.preventDefault();
      var url = s.getAttribute('data-url') || window.location.href;
      var title = s.getAttribute('data-title') || document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); }
      else { window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), '_blank', 'noopener'); }
    }
  });

  /* Flèches de défilement (ordinateur) pour les listes qui défilent : Vus récemment… */
  function navState(sec) {
    var n = sec && sec.querySelector('[data-aty-snav]');
    var l = sec && sec.querySelector('.aty-scroll');
    if (!n || !l) return;
    var max = l.scrollWidth - l.clientWidth;
    n.hidden = max < 4;
    var b = n.querySelectorAll('[data-aty-nav]');
    if (b[0]) b[0].disabled = l.scrollLeft < 4;
    if (b[1]) b[1].disabled = l.scrollLeft > max - 4;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aty-nav]');
    if (!b) return;
    var sec = b.closest('.aty');
    var l = sec && sec.querySelector('.aty-scroll');
    if (!l) return;
    var card = l.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(l).columnGap || 0) : l.clientWidth;
    var per = Math.max(1, Math.floor((l.clientWidth + 1) / step));
    var delta = parseInt(b.getAttribute('data-aty-nav'), 10) * per * step;
    var from = l.scrollLeft;
    l.scrollBy({ left: delta, behavior: 'smooth' });
    setTimeout(function () {
      if (Math.abs(l.scrollLeft - from) < 2) l.scrollLeft = from + delta;
      navState(sec);
    }, 500);
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('aty-scroll')) navState(t.closest('.aty'));
  }, true);
  window.addEventListener('resize', function () { document.querySelectorAll('[data-aty-snav]').forEach(function (n) { navState(n.closest('.aty')); }); });

  /* Compteur de favoris : chaque ajout ou retrait part vers le Google Sheet réglé dans le thème (rien n'est envoyé sinon) */
  function track(action, h) {
    var hook = CFG.favHook;
    if (!hook || !/^https:\/\/script\.google(usercontent)?\.com\//.test(hook) || window.Shopify && window.Shopify.designMode) return;
    /* Un retrait n'est compté que si l'ajout l'a été (les favoris d'avant le compteur ne font pas de négatif) */
    var sent = load('atyFavSent'), k = sent.indexOf(h);
    if (action === 'add') { if (k < 0) sent.push(h); }
    else if (k < 0) return;
    else sent.splice(k, 1);
    save('atyFavSent', sent.slice(-200));
    fetchProduct(h).then(function (p) {
      var body = new URLSearchParams({ a: action, h: h, t: p && p.title ? p.title : h });
      try { fetch(hook, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }); }
      catch (e) { try { navigator.sendBeacon(hook, body); } catch (e2) {} }
    });
  }

  /* Icône favoris dans l'en-tête (à côté du panier) */
  function headerIcon() {
    if (document.querySelector('.aty-hfav')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.href = CFG.favUrl || '/pages/favoris';
    a.className = 'header__icon link focus-inset aty-hfav';
    a.setAttribute('aria-label', 'Mes favoris');
    a.innerHTML = HEART + '<span class="aty-hfav__count" data-aty-favcount hidden>0</span>';
    cart.parentNode.insertBefore(a, cart);
  }

  /* Mobile : la recherche passe à gauche, à côté du menu, pour que le logo reste bien au centre
     (menu + recherche à gauche, favoris + panier à droite). Sur ordinateur, elle reprend sa place. */
  var searchHome = null;
  function placeSearch() {
    var header = document.querySelector('header.header');
    if (!header) return;
    var search = header.querySelector('.header__icons > .header__search') || header.querySelector(':scope > .header__search.aty-msearch');
    if (!search) return;
    var mobile = !window.matchMedia('(min-width: 990px)').matches;
    if (mobile && search.parentNode !== header) {
      searchHome = { parent: search.parentNode, next: search.nextElementSibling };
      var drawer = header.querySelector(':scope > header-drawer');
      header.insertBefore(search, drawer ? drawer.nextSibling : header.firstChild);
      search.classList.add('aty-msearch');
      header.classList.add('aty-hbal');
    } else if (!mobile && search.parentNode === header && searchHome && searchHome.parent.isConnected) {
      searchHome.parent.insertBefore(search, searchHome.next && searchHome.next.parentNode === searchHome.parent ? searchHome.next : searchHome.parent.firstChild);
      search.classList.remove('aty-msearch');
      header.classList.remove('aty-hbal');
    }
  }
  try { window.matchMedia('(min-width: 990px)').addEventListener('change', placeSearch); } catch (e) {}

  /* Pastille de durée (même règle que le snippet aty-duration) */
  function durBadge(p) {
    if (CFG.durBadge === false) return '';
    var norm = function (x) { return String(x || '').toLowerCase().replace(/é/g, 'e').trim(); };
    var lbl = '', range = false;
    (p.tags || []).some(function (t) { if (norm(t).indexOf('duree:') === 0) { lbl = String(t).split(':').pop().trim(); return true; } return false; });
    if (!lbl) {
      var names = String(CFG.durOptions || 'Durée, Duree, Duration, Formule, Abonnement').split(',').map(norm);
      (p.options || []).some(function (o) {
        if (!o || !names.some(function (n) { return n && norm(o.name).indexOf(n) > -1; })) return false;
        var vals = (o.values || []).map(function (x) { return String(x).split('(')[0].trim(); });
        if (vals.length === 1) lbl = vals[0];
        else if (vals.length > 1) {
          var a = String(vals[0]).trim(), b = String(vals[vals.length - 1]).trim();
          var ua = a.replace(/^\S+\s*/, ''), ub = b.replace(/^\S+\s*/, '');
          lbl = (ua && ua === ub ? a.split(' ')[0] : a) + ' à ' + b;
          range = true;
        }
        return true;
      });
    }
    var l = lbl.toLowerCase(), n = parseInt(l, 10) || 0;
    if (!n) return '';
    var mo = /\ban/.test(l) ? n * 12 : (/jour|semaine/.test(l) ? 0 : n);
    var tier = range ? 'range' : mo >= 12 ? 'gold' : mo >= 6 ? 'dark' : mo >= 3 ? 'accent' : 'soft';
    var esc = (window.atyUtil && window.atyUtil.esc) || function (x) { return x; };
    return '<span class="aty-badge aty-badge--dur aty-dur--' + tier + '">' + esc(lbl) + '</span>';
  }

  /* Pastilles Précommande et Avant-première (balises precommande / avant-premiere) */
  function clubBadges(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var out = '';
    if (tags.indexOf('precommande') > -1 || tags.indexOf('précommande') > -1) out += '<span class="aty-badge aty-badge--pre">Précommande</span>';
    if (tags.indexOf('avant-premiere') > -1 || tags.indexOf('avant-première') > -1) out += '<span class="aty-badge aty-badge--ap" title="Réservé aux membres du Club"><svg class="aty-icon" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 7.2l4.6 3.9L12 4l4.4 7.1L21 7.2l-1.9 10.3H4.9z"/><rect x="4.9" y="18.6" width="14.2" height="2.2" rx="1.1" fill="currentColor"/></svg><span class="aty-badge__txt">Réservé au Club</span></span>';
    return out;
  }

  /* Cartes construites à partir des fiches produit (favoris, vus récemment) */
  function cardHtml(p, isFav) {
    var U = window.atyUtil || {};
    var t = U.splitTitle ? U.splitTitle(p.title) : { name: p.title, sub: '' };
    var esc = U.esc || function (x) { return x; };
    var money = U.money || function (x) { return x; };
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var pct = sale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var img = p.featured_image ? (U.imgUrl ? U.imgUrl(p.featured_image, 600) : p.featured_image) : '';
    var multi = p.variants && p.variants.length > 1;
    return '<div class="aty-card' + (p.available ? '' : ' is-soldout') + '">' +
      '<div class="aty-card__media"><a href="' + esc(p.url) + '" class="aty-card__link" tabindex="-1" aria-hidden="true">' + (img ? '<img class="aty-card__img" src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="aty-card__badges">' + (!p.available ? '<span class="aty-badge aty-badge--out">Épuisé</span>' : (sale ? '<span class="aty-badge aty-badge--sale">-' + pct + '%</span>' : '')) + durBadge(p) + clubBadges(p) + '</div>' +
      '<button type="button" class="aty-fav" data-aty-fav="' + esc(p.handle) + '" aria-pressed="' + (isFav ? 'true' : 'false') + '" aria-label="Favori">' + HEART + '</button>' +
      (p.available ? '<div class="aty-qa"><button type="button" class="aty-qa__btn" data-aty-qa="' + esc(p.url) + '"' + (multi ? '' : ' data-variant="' + p.variants[0].id + '"') + ' aria-label="Ajouter au panier"><svg class="aty-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>' : '') +
      '</div><div class="aty-card__info"><a href="' + esc(p.url) + '" class="aty-card__name">' + esc(t.name) + '</a>' + (t.sub ? '<div class="aty-card__sub">' + esc(t.sub) + '</div>' : '') +
      '<div class="aty-card__price"><span class="aty-card__now' + (sale ? ' is-sale' : '') + '">' + esc(money(p.price)) + '</span>' + (sale ? '<s class="aty-card__was">' + esc(money(p.compare_at_price)) + '</s>' : '') + '</div></div></div>';
  }

  var cache = {};
  function fetchProduct(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }

  function renderInto(box, handles, isFav) {
    var grid = box.querySelector('[data-aty-list]');
    var empty = box.querySelector('[data-aty-empty]');
    if (!grid) return;
    if (!handles.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; if (box.hasAttribute('data-aty-hide-empty')) box.hidden = true; return; }
    if (empty) empty.hidden = true;
    box.hidden = false;
    Promise.all(handles.map(fetchProduct)).then(function (list) {
      var ok = [], gone = [];
      list.forEach(function (p, i) { if (p) ok.push(p); else gone.push(handles[i]); });
      if (isFav && gone.length) { save(FKEY, load(FKEY).filter(function (h) { return gone.indexOf(h) < 0; })); sync(); }
      var favs = load(FKEY);
      grid.innerHTML = ok.map(function (p) { return cardHtml(p, favs.indexOf(p.handle) > -1); }).join('');
      if (!ok.length) { if (empty) empty.hidden = false; if (box.hasAttribute('data-aty-hide-empty')) box.hidden = true; }
      navState(box);
      var c = box.querySelector('[data-aty-listcount]');
      if (c) c.textContent = ok.length ? String(ok.length) : '';
    });
  }

  function renderLists() {
    document.querySelectorAll('[data-aty-favpage]').forEach(function (box) { renderInto(box, load(FKEY), true); });
    document.querySelectorAll('[data-aty-recent]').forEach(function (box) {
      var ex = box.getAttribute('data-exclude');
      var max = parseInt(box.getAttribute('data-max'), 10) || 8;
      renderInto(box, load(RKEY).filter(function (h) { return h !== ex; }).slice(0, max), false);
    });
  }

  /* Fiche produit vue : mémorisée pour « Vus récemment » */
  function remember() {
    var el = document.querySelector('[data-aty-viewed]');
    if (!el) return;
    var h = el.getAttribute('data-aty-viewed');
    var r = load(RKEY).filter(function (x) { return x !== h; });
    r.unshift(h);
    save(RKEY, r.slice(0, MAXR));
  }

  function navAll() { document.querySelectorAll('[data-aty-snav]').forEach(function (n) { navState(n.closest('.aty')); }); }
  function init() { headerIcon(); placeSearch(); sync(); renderLists(); remember(); navAll(); window.addEventListener('load', navAll); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { searchHome = null; headerIcon(); placeSearch(); sync(); renderLists(); navAll(); });
  window.addEventListener('storage', function (e) { if (e.key === FKEY) sync(); });
})();
